import React from "react";
import { IoClose } from "react-icons/io5"; // close icon from react-icons
import { useNavigate } from "react-router-dom";


const Success = () => {

    const navigate = useNavigate()
    const handleContinue = () => {
        navigate('/dashboard/home')
    }
    return (
        <div className="h-screen w-screen flex justify-center items-center p-4">
            <div className="relative w-full max-w-sm  bg-white/50  rounded-lg p-6 flex flex-col items-center text-center
              backdrop-blur-3xl shadow-[0_0_10px_rgba(0,0,0,0.2)] border border-gray-300
     
      
         dark:bg-[#1d1d1f]
            ">

                {/* Close Button */}
                {/* Close Button */}
                {/* <button
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                    onClick={() => } // replace with your close handler
                >
                    <IoClose size={22} />
                </button> */}

                {/* Success Icon */}
                <img
                    src="/assets/paymentsuccess.png"
                    alt="success icon"
                    className="w-24 h-24 object-contain mb-4"
                />

                {/* Success Text */}
                <div className="text-gray-800 font-bold text-lg  mb-2">
                    Payment Successful!
                </div>
                <p className="text-gray-600 text-sm mb-6">
                    Your payment has been processed successfully.
                    You can now continue trading.
                </p>

                {/* Button */}


                <button onClick={handleContinue} className="bg-green-500 shadow-lg text-white px-5 py-2 rounded-lg hover:bg-green-700 transition">
                    Continue Trading
                </button>
            </div>
        </div>
    );
};

export default Success;
